export const SELECT_STEP_SUCCESS = 'SELECT_STEP_SUCCESS';
export const SELECT_BUSINESS_SUCCESS = 'SELECT_BUSINESS_SUCCESS';
export const SHOW_NEXT_STEP_SUCCESS = 'SHOW_NEXT_STEP_SUCCESS';
export const SELECT_BUSINESS_AREA_SUCCESS = 'SELECT_BUSINESS_AREA_SUCCESS';
export const SELECT_BUSINESS_TYPE_SUCCESS = 'SELECT_BUSINESS_TYPE_SUCCESS';
export const SET_DAMAGED_SUCCESS = 'SET_DAMAGED_SUCCESS';
export const SET_EMPLOYEES_SUCCESS = 'SET_EMPLOYEES_SUCCESS';
export const SET_HOUSECOMPANY_SUCCESS = 'SET_HOUSECOMPANY_SUCCESS';
export const SET_PERSONAL_TERMS_ACCEPTED = 'SET_PERSONAL_TERMS_ACCEPTED';
export const SET_OTHER_BUSINESS_TYPE_SUCCESS = 'SET_OTHER_BUSINESS_TYPE_SUCCESS';
export const UPDATE_CUSTOMER_SECTION = 'UPDATE_CUSTOMER_SECTION';

export const selectStepSuccess = (data) => {
    return {
        type: SELECT_STEP_SUCCESS,
        data: data
    }
};

export const selectStep = (step) => {

    return (dispatch) => {
        dispatch(selectStepSuccess(step));
    }
};


export const selectBusinessSuccess = (data) => {
    return {
        type: SELECT_BUSINESS_SUCCESS,
        data: data
    }
};


export const selectBusiness = (business) => {

    return (dispatch) => {
        dispatch(selectBusinessSuccess(business));
    }
};

export const setOtherBusinessTypeSuccess = (data) => {
    return {
        type: SET_OTHER_BUSINESS_TYPE_SUCCESS,
        data: data
    }
};

export const setOtherBusinessType = (description) => {

    return (dispatch) => {
        dispatch(setOtherBusinessTypeSuccess(description));
    }
};

export const showNextStepSuccess = () => {
    return {
        type: SHOW_NEXT_STEP_SUCCESS,
    }
};

export const showNextStep = () => {
    return (dispatch) => {
        dispatch(showNextStepSuccess());
    }
};

export const setAdditionalInsuranceFromApi = (data) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_ADDITIONAL_INSURANCE_FROM_API',
      data: data
    })
  }
}

export const setAttachmentsFromApi = (data) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_ATTACHMENTS_FROM_API',
      data: data
    })
  }
}

export const setHouseCompanySuccess = (data) => {
    return {
        type: SET_HOUSECOMPANY_SUCCESS,
        data: data
    }
};

export const setHouseCompany = (data) => {
    return (dispatch) => {
        dispatch(setHouseCompanySuccess(data));
    }
};

export const updateCustomerSection = (data) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_CUSTOMER_SECTION,
      data: data
    })
  }
}

export const acceptPersonalTermsSuccess = (bool) => {
    return {
        type: SET_PERSONAL_TERMS_ACCEPTED,
        data: bool
    }
};

export const setTextSelection = (data) => {
  return {
    type: 'SET_TEXT_SELECTION',
    data: data
  }
}

export const acceptPersonalTerms = (bool) => {
    return (dispatch) => {
        dispatch(acceptPersonalTermsSuccess(bool));
    }
};

export const acceptConsentInformation = (bool) => {
  return (dispatch) => {
    dispatch({
      type: 'ACCEPT_CONSENT_INFORMATION',
      data: bool
    });
  }
}